import { api } from '../config/api'

const categoryBaseEndpoint = '/CategoryApi'

export const getCategories = () => api.get(categoryBaseEndpoint)

export const getCategory = id => api.get(`${categoryBaseEndpoint}/${id}`)
